module.exports = __webpack_public_path__ + "983f37ab1df6c9d6e2b21b1aa0f0025e.jpg";